import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SortHeaderComponent } from './sort-header.component';

/**
 * Sıralanabilir tablo başlığı kendi modülünde duruyor çünkü hem muhasebe
 * listeleri hem de banka hareketleri (specifications) ekranı kullanıyor;
 * birinin modülüne koymak diğerini o modüle bağımlı kılardı.
 */
@NgModule({
  declarations: [SortHeaderComponent],
  imports: [CommonModule],
  exports: [SortHeaderComponent],
})
export class SortHeaderModule {}
